const API_URL = import.meta.env.VITE_API_URL || 'https://butchers-api.workers.dev'

export const api = {
  async login(password: string) {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    })
    return res.json()
  },

  async verifyToken(token: string) {
    const res = await fetch(`${API_URL}/api/auth/verify`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    return res.json()
  },

  async getPosts(token: string) {
    const res = await fetch(`${API_URL}/api/admin/posts`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    return res.json()
  },

  async createPost(token: string, postData: any) {
    const res = await fetch(`${API_URL}/api/admin/posts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(postData)
    })
    return res.json()
  },

  async updatePost(token: string, slug: string, postData: any) {
    const res = await fetch(`${API_URL}/api/admin/posts`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ slug, ...postData })
    })
    return res.json()
  },

  async deletePost(token: string, slug: string) {
    const res = await fetch(`${API_URL}/api/admin/posts?slug=${slug}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    })
    return res.json()
  }
}

export interface Post {
  slug: string
  title: string
  category: string
  date: string
  featured: boolean
  content?: string
  excerpt?: string
  tags?: string[]
  metaDescription?: string
}

export const getPost = async (slug: string): Promise<Post | null> => {
  try {
    const response = await fetch(`${API_URL}/api/posts/${slug}`);
    if (!response.ok) {
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching post:', error);
    return null;
  }
};
